import Icons from './Icons';
const IconsModule = [
   {
      path: 'icons',
      element: <Icons />,
   },
];
export default IconsModule;
